import React, { useEffect, useState } from 'react';
import { Box, Typography, FormControl, FormLabel, TextField, IconButton, Autocomplete } from '@mui/material';
import Grid from "@mui/material/Grid2";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployeeByid } from '../../redux/Slice/employeeSlice';
import { Link, useParams } from "react-router-dom";
import { setLoading } from "../../redux/Slice/loaderSlice";
import { clearMessage } from "../../redux/Slice/message";
import { toast } from "sonner";
import { ArrowBack } from '@mui/icons-material';
import { Country } from "country-state-city";
import { getCountryCallingCode } from "libphonenumber-js";

const EmployeeDetails = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const id = params?.id;

  const [selectedCountry, setSelectedCountry] = useState("");
  const { employeeDetail } = useSelector((state) => state.employee);
  const message = useSelector((state) => state.message);
  console.log("emp",employeeDetail)

  useEffect(() => {
    dispatch(setLoading(true))

    if (id) {
      dispatch(fetchEmployeeByid({e_id:id}));
    }
    dispatch(setLoading(false)) 
  }, [dispatch, id]);


  const countries = Country.getAllCountries().filter(country => {
    try {
      getCountryCallingCode(country.isoCode);
      return true;
    } catch (error) {
      return false;
    }
  });

  useEffect(() => {
    if (employeeDetail?.country_code) {
      const countryCode = employeeDetail.country_code.replace('+', '');
      // Find country by calling code
      const matchingCountry = countries.find(country => {
        try {
          return getCountryCallingCode(country.isoCode) === countryCode;
        } catch (error) {
          return false;
        }
      });
      
      if (matchingCountry) {
        setSelectedCountry(matchingCountry.name);
      } 
    }
  }, [employeeDetail, countries]);


  useEffect(() => {
    if (message?.message) {
      toast(message.message);
      dispatch(clearMessage());
    }
  }, [message, dispatch]);


  return (
    <div className="content">
           <Box sx={{ display: "flex", alignItems: "center", p: 2 }}>
        <Link to="/employee">
          <IconButton>
            <ArrowBack />
          </IconButton>
        </Link>
        <Typography variant="h5" sx={{ marginLeft: 2 }}>
          Employee Details
        </Typography>
      </Box>
      
      <Grid container spacing={2} sx={{ p: 3, border: '1px solid #ddd', borderRadius: 2 }}>
        <Grid item size={6}>
          <Box>
            <Typography variant="h5" sx={{ mb: 2 }}>
              General Information
            </Typography>
            
            <FormControl fullWidth sx={{ mb: 2 }}>
              <FormLabel htmlFor="name">Full Name</FormLabel>
              <TextField
                id="name"
                name="name"
                variant="outlined"
                fullWidth
                value={employeeDetail?.name || ''}
                InputProps={{
                  readOnly: true,
                }}
              />
            </FormControl>

            <FormControl fullWidth sx={{ mb: 2 }}>
              <FormLabel>Role</FormLabel>
              <TextField
                variant="outlined"
                fullWidth
                value={employeeDetail?.role?.name || ''}  
                InputProps={{
                  readOnly: true,
                }}
              />
            </FormControl>

            <FormControl fullWidth sx={{ mb: 2 }}>
              <FormLabel htmlFor="phoneNumber">Phone Number</FormLabel>
              <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                {/* Country Code Input */}
                <TextField
                  id="country_code"
                  name="country_code"
                  variant="outlined"
                  sx={{ width: "80px" }}
                  value={employeeDetail?.country_code || ''}
                  InputProps={{
                    readOnly: true,
                  }}
                />
                
                {/* Country display */}
                <Autocomplete
                  disablePortal
                  options={countries.map((country) => country.name)}
                  value={selectedCountry}
                  readOnly
                  disabled
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Country"
                      sx={{ width: "300px" }}
                      InputProps={{
                        ...params.InputProps,
                        readOnly: true,
                      }}
                    />
                  )}
                  // sx={{ width: "300px" }}
                />
                
                {/* Phone Number Input */}
                <TextField
                  id="phoneNumber"
                  name="phoneNumber"
                  variant="outlined"
                  fullWidth
                  value={employeeDetail?.phoneNumber || ''}
                  InputProps={{
                    readOnly: true,
                  }}
                  sx={{ width: "300px" }}
                />
              </Box>
            </FormControl>

            <FormControl fullWidth sx={{ mb: 2 }}>
              <FormLabel htmlFor="email">Email ID</FormLabel>
              <TextField
                id="email"
                name="email"
                variant="outlined"
                fullWidth
                value={employeeDetail?.email || ''}
                InputProps={{
                  readOnly: true,
                }}
              />
            </FormControl>

            <FormControl fullWidth sx={{ mb: 2 }}>
              <FormLabel htmlFor="designation">Designation</FormLabel>
              <TextField
                id="designation"
                name="designation"
                variant="outlined"
                fullWidth
                value={employeeDetail?.designation || ''}
                InputProps={{
                  readOnly: true,
                }}
              />
            </FormControl>

            <FormControl fullWidth sx={{ mb: 2 }}>
              <FormLabel htmlFor="linkedinUrl">LinkedIn URL</FormLabel>
              <TextField
                id="linkedinUrl"
                name="linkedinUrl"
                variant="outlined"
                fullWidth
                value={employeeDetail?.linkedinUrl || ''}
                InputProps={{
                  readOnly: true,
                }}
              />
            </FormControl>
          </Box>
        </Grid>

        <Grid item size={{md:6, xs:12}} display="flex" justifyContent="center" alignItems="center">
          <Box sx={{ textAlign: 'center' }}>
            {employeeDetail?.imgUrl ? (
              <img
                src={employeeDetail.imgUrl}
                alt="Profile"
                style={{ width: 150, height: 180, objectFit: 'cover', borderRadius: '8px' }}
              />
            ) : (
              <Box sx={{ 
                width: 150, 
                height: 180, 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                border: '1px dashed #ccc',
                borderRadius: '8px'
              }}>
                <Typography>No Profile Image</Typography>
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default EmployeeDetails;


